module.exports = __webpack_public_path__ + "img/W-C94.9661b3e0.jpg";